/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, ADSEC){
	const a = 'is-active';
	const v = 'is-visible';
	const arrowPrev = '<button type="button" class="slick-prev"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg></button>';
	const arrowNext = '<button type="button" class="slick-next"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg></button>';
	const $path = location.pathname;
	const $param = location.search.replace('?', '');

	// <カテゴリ別一覧>中カテゴリ リスト取得用
	const getJSONmediumCategory = (_cat) => {
		return $.getJSON(`/ajax/products/${_cat}.json`);
	};
	// <カテゴリ別一覧>小カテゴリ リスト取得用
	const getJSONsmallCategory = (_cat, _mediumCat) => {
		return $.getJSON(`/ajax/products/${_cat}/${_mediumCat}.json`);
	};
	// <目的・事業別一覧>目的・事業
	const getJSONpurposeTag = (_tag) => {
		return $.getJSON(`/ajax/products/purpose/${_tag}.json`);
	};
	// <メーカー別一覧>商品取得用
	const getJSONmakerProducts = (_id) => {
		return $.getJSON(`/ajax/products/maker/${_id}.json`);
	};
	// <商品詳細>関連商品key取得用
	const getJSONrelationProductsKey = (_id) => {
		return $.getJSON(`/ajax/products/related/${_id}.json`);
	};
	// <商品詳細>関連商品出力用JSON取得用
	const getJSONrelationProductsList = (_id) => {
		return $.getJSON(`/ajax/products/detail1/${_id}.json`);
	};
	// <商品詳細>商品出小カテゴリ取得用
	const getJSONproductCategory = (_id) => {
		return $.getJSON(`/ajax/products/category/${_id}.json`);
	};
	// <商品詳細>商品出小カテゴリでの関連商品出力用JSON取得用
	const getJSONproductCategoryRelationList = (_id) => {
		return $.getJSON(`/ajax/products/detail2/${_id}.json`);
	};

	// <カテゴリ別一覧>小カテゴリプルダウン
	const selectCategory_small = (_cat, _mediumCat) => {
		let paramArr = {};
		let paramSmallCat = '';
		if($param) {
			for(let i=0; $param.split('&')[i]; i++) {
				let k = $param.split('&')[i].split('=');
				paramArr[k[0]] = k[1];
			}
			paramSmallCat = paramArr.cat2;
		}
		getJSONsmallCategory(_cat, _mediumCat).then((data) => {
			if(data.rt_bn_products_category.length) {
				let catData = data.rt_bn_products_category;
				for(let i = 0; i < catData.length; i++) {
					let thisCode = catData[i].cf_pc_code;
					let thisName = catData[i].cf_pc_name;
					let thisOption;
					if(thisCode === paramSmallCat) {
						thisOption = '<option value="'+ thisCode +'" class="js-option" selected="selected">'+ thisName +'</option>';
						$('.js-sort-category').text($('.js-sort-category').text() +'、'+ thisName);
					} else {
						thisOption = '<option value="'+ thisCode +'" class="js-option">'+ thisName +'</option>';
					}
					$('.js-selectCat_small').append(thisOption);
				}
			}
		});
	};
	// <カテゴリ別一覧>プルダウン
	const selectCategory = () => {
		const category = $path.split('/')[$path.split('/').length -2];
		let paramArr = {};
		let paramMediumCat = '';
		let paramSmallCat = '';
		if($param) {
			for(let i=0; $param.split('&')[i]; i++) {
				let k = $param.split('&')[i].split('=');
				paramArr[k[0]] = k[1];
			}
			paramMediumCat = paramArr.cat1;
			paramSmallCat = paramArr.cat2;
		}

		$('.js-searchForm').attr('action', '/products/'+ category +'/result.html');

		// 中カテゴリプルダウン描画
		getJSONmediumCategory(category).then((data) => {
			let catArr = [];
			if(data.rt_bn_products_category.length) {
				let catData = data.rt_bn_products_category;
				for(let i = 0; i < catData.length; i++) {
					let thisCode = catData[i].cf_pc_second_code;
					let thisName = catData[i].cf_pc_second_name;

					if(catArr.indexOf(thisCode) === -1) {
						let thisOption;
						catArr.push(thisCode);
						if(thisCode === paramMediumCat) {
							thisOption = '<option value="'+ thisCode +'" selected="selected">'+ thisName +'</option>';
							$('.js-sort-category').text(thisName);
						} else {
							thisOption = '<option value="'+ thisCode +'">'+ thisName +'</option>';
						}
						$('.js-selectCat_medium').append(thisOption);
					}
				}
			}
		}).done(() => {
			// 小カテゴリのみパラメータに値が入っている場合
			if(paramMediumCat === '' && paramSmallCat !== '') {
				$('.js-selectCat_medium').find('option').each((idx, ele) => {
					let thisMcat = $(ele).attr('value');
					let thisMcatName = $(ele).text();
					getJSONsmallCategory(category, thisMcat).then((data) => {
						if(data.rt_bn_products_category.length) {
							let catData = data.rt_bn_products_category;
							for(let i = 0; i < catData.length; i++) {
								let thisCode = catData[i].cf_pc_code;
								if(paramSmallCat === thisCode) {
									$(ele).prop('selected', true);
									$('.js-selectCat_medium').change();
									$('.js-sort-category').text(thisMcatName);
									break;
								}
							}
						}
					});
				});
			}
		});
		// 小カテゴリプルダウン描画
		if(paramMediumCat !== '') {
			selectCategory_small(category, paramMediumCat);
			$('.js-selectCat_small').removeClass('is-disable');
		}
		$('.js-selectCat_medium').on('change', () => {
			let mediumCat = $('.js-selectCat_medium').find('option:selected').val();
			$('.js-selectCat_small .js-option').remove();
			if(mediumCat !== '') {
				$('.js-selectCat_small').removeClass('is-disable');
				selectCategory_small(category, mediumCat);
			} else {
				$('.js-selectCat_small').addClass('is-disable');
			}
		});

		// 検索条件をクリア
		$('.js-clear').on('click', () => {
			$('.js-selectCat_medium').val('');
			$('.js-selectCat_small .js-option').remove();
			$('.js-selectCat_small').addClass('is-disable');
		});
	};
	// <大カテゴリ別一覧>商品一覧
	const categoryProductsList = () => {
		// アンカー重複削除
		if($('.js-category-anchor').length) {
			let catArr = [];
			$('.js-category-anchor').each((idx, ele) => {
				let thisCatName =  $(ele).find('.rt_cf_pc_second_name').text();
				if(catArr.indexOf(thisCatName) === -1) {
					catArr.push(thisCatName);
					$(ele).removeClass('di_none');
				} else {
					$(ele).remove();
				}
				// アンカー設置
				$('.js-category-block').each((idx2, ele2) => {
					let thisName = $(ele2).find('.rt_cf_pc_second_name').text();
					let thisCode = $(ele2).find('.rt_cf_pc_second_code_hidden').text();
					$(ele2).attr('id', thisCode);
					if(thisCatName === thisName) {
						$(ele).find('.mod-button-a').attr('href', '#'+thisCode);
					}
				});
			});
		}

		// 商品4件まで表示
		$('.js-category-item').each((idx, ele) => {
			let catCode = $(ele).parents('.js-category-block').find('.rt_cf_pc_second_code_hidden').text();
			let catArr = [];
			$(ele).find('.rt_cf_pc_second_code').each((idx2, ele2) => {
				catArr.push($(ele2).text());
			});
			if(catArr.indexOf(catCode) !== -1) {
				$(ele).removeClass('di_none');
				// 商品が5件以上の場合「もっと見る」ボタンを表示
				let displayItem = $(ele).parents('.js-category-block').find('.js-category-item:not(.di_none):gt(3)').length;
				if(displayItem > 0) {
					$(ele).parents('.js-category-block').find('.js-products-moreBtn').removeClass('di_none');
				}
				// 商品が5件目以降非表示
				$(ele).parents('.js-category-block').find('.js-category-item:not(.di_none):gt(3)').addClass('di_none');
			}
		});

		// 中カテゴリブロック重複削除&商品0件の場合非表示
		if($('.js-category-block').length) {
			let catArr = [];
			$('.js-category-block').each((idx, ele) => {
				let thisCatCode =  $(ele).find('.rt_cf_pc_second_code_hidden').text();
				if(catArr.indexOf(thisCatCode) === -1) {
					catArr.push(thisCatCode);
					$(ele).removeClass('di_none');
				} else {
					$(ele).remove();
				}

				if(!$(ele).find('.js-category-item:not(.di_none)').length) {
					$(ele).addClass('di_none');
					$('.mod-button-a[href="#'+thisCatCode+'"]').parents('.js-category-anchor').remove();
				}
			});
		}

		// 「他のカテゴリを見る」カレントのカテゴリを非表示
		$('.js-other-category').each((idx, ele) => {
			let thisHref = $(ele).find('.mod-boxLink06').attr('href');
			if(thisHref === $path || thisHref === $path + 'index.html') {
				$(ele).remove();
			}
		});
	};

	// <目的・事業別一覧>目的・事業
	const purposeTag = () => {
		let purposeCode = $path.split('/')[$path.split('/').length -2];
		let catArr = [];
		let makerArr = [];

		getJSONpurposeTag(purposeCode).then((data) => {
			let tagData = data.rt_bn_products;
			if(tagData.length) {
				for(let i=0; i<tagData.length; i++) {
					let thisCatArr = tagData[i].cf_p_category;
					let thisMaker = tagData[i].cf_p_maker_tags;
					if(thisMaker !== null) {
						makerArr.push(thisMaker._key);
					}
					for(let j=0; j<thisCatArr.length; j++) {
						catArr.push(thisCatArr[j].cf_pc_first_code);
					}
				}
			}

			// カテゴリから探す
			$('.js-category-code').each((idx, ele) => {
				let thisCode = $(ele).text();
				if(catArr.indexOf(thisCode) !== -1) {
					$(ele).parents('.js-category').removeClass('di_none');
				}
			});
			// メーカーから探す
			$('.js-maker-key').each((idx, ele) => {
				let thisKey = $(ele).text();
				if(makerArr.indexOf(thisKey) !== -1) {
					$(ele).parents('.js-maker').removeClass('di_none');
				}
			});
		}).done(() => {
			// 「カテゴリから探す」の0件メッセージ表示
			if(!$('.js-category:not(.di_none)').length) {
				$('.js-category-msg').removeClass('di_none');
				$('.products-cat-others-list').addClass('di_none');
			}
			// 「メーカーから探す」の0件メッセージ表示
			if(!$('.js-maker:not(.di_none)').length) {
				$('.js-maker-msg').removeClass('di_none');
				$('.products-maker-list').addClass('di_none');
			}
		});
	};

	// <メーカー別一覧>「商品一覧」描画
	const makerProducts = () => {
		const makerId = $path.split('/')[$path.split('/').length -2];
		getJSONmakerProducts(makerId).then((data) => {
			let prodList = data.rt_bn_products;
			if(prodList.length) {
				for(let i=0; i<prodList.length; i++) {
					let _name = prodList[i].cf_p_product;
					let _img = prodList[i].cf_p_thumbnail_img;
					let _model = prodList[i].cf_p_model;
					let _key = prodList[i]._key;
					let _catList = prodList[i].cf_p_category;

					for(let j=0; j<_catList.length; j++) {
						let thisFirstCode = _catList[j].cf_pc_first_code;
						let thisFirstCodeName = _catList[j].cf_pc_first_name_jp;
						let thisSecondCode = _catList[j].cf_pc_second_code;
						let thisSecondCodeName = _catList[j].cf_pc_second_name;
						let prodHtml = '<li class="pure-u-1-4 pure-u-md-1-2 products-list-item" data-key="'+_key+'">'+
						'<div class="mod-boxLink05">'+
						'<a href="/products/'+thisFirstCode+'/'+_key+'/" class="__img">'+
						'<img src="/products/products_file/file/'+_img+'" alt="'+_name+'" class="">'+
						'</a><a href="" class="__name">'+_name+'</a>'+
						'<span class="__num">'+_model+'</span></div></li>';

						let thisCatBlock = $('.js-products-block[data-code="'+thisSecondCode+'"]');
						if(thisCatBlock.length) {
							let thisItem = $('.js-products-block[data-code="'+thisSecondCode+'"] .products-list-item[data-key="'+_key+'"]');
							if(!thisItem.length) {
								let count = Number(thisCatBlock.attr('data-count'));
								count += 1;
								thisCatBlock.attr('data-count', count);

								let thisItemLen = thisCatBlock.find('.products-list-item').length;
								// 4件まで表示
								if(thisItemLen < 4) {
									thisCatBlock.find('.js-products-list').append(prodHtml);
								}
								// 4件以上ある場合はボタン設置
								if(count > 4) {
									if(!$('.js-products-more').length) {
										let btnHtml = '<div class="mod-button _260 __black mt60 js-products-more">'+
										'<a href="/products/'+thisFirstCode+'/result.html?cat1='+thisSecondCode+'&cat2=" class="mod-button-a">'+
										'<span>もっと見る</span>'+
										'<svg class="icon mod-iconRight"><use xlink:href="/common/svg/sprite.svg#arrow_right"></use></svg>'+
										'</a></div>';
										thisCatBlock.append(btnHtml);
									}
								}
							}
						} else {
							let prodBlockHtml = '<div class="js-products-block" data-code="'+thisSecondCode+'" data-count="1">'+
							'<h3 class="mod-head12"><span class="__large">'+thisFirstCodeName+'</span>'+
							'<span class="__small">'+thisSecondCodeName+'</span></h3>'+
							'<ul class="pure-g products-list opacity js-products-list">'+prodHtml+'</ul></div>';
							$('.js-products-output').append(prodBlockHtml);
						}
					}
				}
			}
		});
	};
	// <メーカー別一覧>「他のメーカーを見る」表示中のメーカーロゴを非表示
	const makerLogo = () => {
		$('.js-maker').each((idx, ele) => {
			let thisHref = $(ele).find('.mod-boxLink07').attr('href');
			if(thisHref === $path || thisHref === $path +'index.html') {
				$(ele).remove();
			}
		});
	};

	// <製品詳細>製品画像スライド
	const productsSlider = () => {
		$('.js-subImg').each((idx, ele) => {
			let thisSrc = $(ele).attr('src');
			if(thisSrc === '') {
				$(ele).parents('.js-subImg-wrap').remove();
			}
		});
		// サムネイル作成
		$('.products-detail-slider').on('init', (event, slick, currentSlide, nextSlide) => {
			let slideItem = $('.products-detail-slider li.slick-slide:not(.slick-cloned)');
			slideItem.each((idx, ele) => {
				let slideImg = slideItem.eq(idx).find('img:visible');
				let dot = $('.slick-dots li').eq(idx).find('button');
				let src = slideImg.attr('src');
				dot.append('<img src="'+ src +'">');
			});
		});
		$('.products-detail-slider').slick({
			autoplay: false,
			fade: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			speed: 500,
			loop: true,
			arrows: false,
			dots: true,
			infinite: false,
			pauseOnFocus: false,
			pauseOnHover: false,
		});
	};

	// <製品詳細>関連商品
	const relationList = () => {
		let $productId = $path.split('/')[$path.split('/').length -2];
		let relationArr = [];

		// <製品詳細>関連商品 第2関連キー（小カテゴリ）から紐づける
		const smallCategoryRelationList = (_prodKey) => {
			// 商品の小カテゴリを取得
			let smallCategoryArr = [];
			getJSONproductCategory(_prodKey).then((dataCat) => {
				let categoryList = dataCat.rt_bn_related_product;
				if(categoryList.length) {
					let categoryListArr = categoryList[0].cf_p_category;
					for(let k=0; k<categoryListArr.length; k++) {
						smallCategoryArr.push(categoryListArr[k].cf_pc_code);
					}
				}
				for(let l=0; l<smallCategoryArr.length; l++) {
					getJSONproductCategoryRelationList(smallCategoryArr[l]).then((dataList) => {
						let prodList2 = dataList.rt_bn_related_product;
						if(prodList2.length) {
							for(let m=0; m<prodList2.length; m++) {
								let thisKey2 = prodList2[m]._key;
								let thisImg2 = prodList2[m].cf_p_thumbnail_img;
								let thisName2 = prodList2[m].cf_p_product;
								let thisModel2 = prodList2[m].cf_p_model;
								let thisCategory2= prodList2[m].cf_p_category[0].cf_pc_first_code;
								if(_prodKey !== thisKey2 && relationArr.indexOf(thisKey2) === -1 && $('.js-relation-item').length < 4) {
									relationArr.push(thisKey2);
									let thisHtml = '<li class="pure-u-1-4 pure-u-md-1-2 products-list-item js-relation-item">'+
									'<div class="mod-boxLink05">'+
									'<a href="/products/'+thisCategory2+'/'+thisKey2+'/" class="__img">'+
									'<img src="/products_file/file/'+thisImg2+'" alt="'+thisName2+'" class="">'+
									'</a><a href="" class="__name">'+thisName2+'</a>'+
									'<span class="__num">'+thisModel2+'</span>'+
									'</div></li>';
									$('.js-relationList').append(thisHtml);
								}
							}
						}
					});
				}
			});
		};

		// 関連商品キー取得～描画 -------------------------
		getJSONrelationProductsKey($productId).then((data) => {
			// 関連商品キーが1件以上ある場合
			if(data.rt_bn_related_product[0].cf_p_products !== null && $('.js-relation-item').length < 4) {
				let $keyArr = data.rt_bn_related_product[0].cf_p_products;
				for(let i=0; i<$keyArr.length; i++) {
					let relationProdKey = $keyArr[i]._key;
					// 第1関連キーから紐づける
					getJSONrelationProductsList(relationProdKey).then((dataKey) => {
						let prodList = dataKey.rt_bn_related_product;
						if(prodList.length) {
							for(let j=0; j < prodList.length; j++) {
								let thisKey = prodList[j]._key;
								let thisImg = prodList[j].cf_p_thumbnail_img;
								let thisName = prodList[j].cf_p_product;
								let thisModel = prodList[j].cf_p_model;
								let thisCategory = prodList[j].cf_p_category[0].cf_pc_first_code;

								if($productId !== thisKey && relationArr.indexOf(thisKey) === -1 && $('.js-relation-item').length < 4) {
									relationArr.push(thisKey);
									let thisHtml = '<li class="pure-u-1-4 pure-u-md-1-2 products-list-item js-relation-item">'+
									'<div class="mod-boxLink05">'+
									'<a href="/products/'+thisCategory+'/'+thisKey+'/" class="__img">'+
									'<img src="/products_file/file/'+thisImg+'" alt="'+thisName+'" class="">'+
									'</a><a href="" class="__name">'+thisName+'</a>'+
									'<span class="__num">'+thisModel+'</span>'+
									'</div></li>';
									$('.js-relationList').append(thisHtml);
								}
							}
						}
						// 現状4件未満の場合、第2関連キーから紐づけたものを描画
						if($('.js-relation-item').length < 4) {
							smallCategoryRelationList($productId);
						}
					});
				}
			} else {
				// 現状4件未満の場合、第2関連キーから紐づけたものを描画
				if($('.js-relation-item').length < 4) {
					smallCategoryRelationList($productId);
				}
			}
		});
	};

	// <製品詳細>概要が空の場合はブロックごと削除
	const outlineBlock = () => {
		if($('.js-outline .mod-tbl01 tbody tr').length || $('.js-outline .bclo-detail').length) {
			$('.js-outline').removeClass('di_none');
		}
	};

	// <製品詳細>特長が空の場合はブロックごと削除
	const featuresBlock = () => {
		if($('.js-features .rt_cf_p_features').length || $('.js-features .bclo-detail').length) {
			$('.js-features').removeClass('di_none');
		}
	};

	// ==============================================================================
	// カテゴリ別一覧
	if($('.products-search').length) {
		selectCategory();
		// 大カテゴリ別一覧
		if($path.indexOf('result.html') === -1) {
			categoryProductsList();
		}
	}
	// <目的・事業別一覧>
	if($path.split('/')[$path.split('/').length -3] === 'purpose') {
		purposeTag();
	}
	// <メーカ－別一覧>
	if($path.split('/')[$path.split('/').length -3] === 'maker') {
		makerProducts();
		makerLogo();
	}
	// 製品詳細
	if($('.products-detail-slider').length) {
		productsSlider();
	}
	if($('.js-relationList').length) {
		relationList();
	}
	if($('.js-outline').length) {
		outlineBlock();
	}
	if($('.js-features').length) {
		featuresBlock();
	}

})(window.jQuery, window.ADSEC);
